import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import QuestionScreen from './GameQuestionScreen';
import AnswerScreen from './GameAnswerScreen';
import PauseScreen from './PauseScreen';
import {setTime,isArrayRandamized,setRandomMythsAndFacts} from '../actions/commonActions';
var intervalId;
class GameMainScreen extends Component {

  UNSAFE_componentWillMount(){
    clearInterval(intervalId);
    intervalId = setInterval(() => this.tick(), 1000);
}

    tick(){
      if(this.props.screenNumber === 1){
        if(localStorage.getItem('game_mode') === "time" && this.props.playTime <= 0){
          clearInterval(intervalId);
          this.props.history.push('/resultscreen');
        }
        this.props.setTime(this.props.playTime -1)
      }
    }

    shuffleArray(array, shuffleEnable = false) {
      var currentIndex = array.length, temporaryValue, randomIndex;
      // While there remain elements to shuffle...
      if(shuffleEnable){
        while (0 !== currentIndex) {
    
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
      }else{
        return array;
      }
    }


    render() {
      if(!this.props.israndamized && this.props.mythsAndFacts.length > 0){
        this.props.setRandomMythsAndFacts(this.shuffleArray(this.props.mythsAndFacts));
        this.props.isArrayRandamized(true);
      }

      
      var screenToLoad = this.props.screenNumber;
      var Screen = null;

      if(screenToLoad === 1){
        Screen = QuestionScreen;
      }else if(screenToLoad === 2) {
        Screen = AnswerScreen;
      }else if(screenToLoad === 3){
        Screen = PauseScreen;
      }
      
          return(
              <div className = "screen_background">
                <Screen/>
              </div>
          )
    }
}

GameMainScreen.propTypes = {
  language:PropTypes.string.isRequired,
  screenNumber:PropTypes.number.isRequired,
  playTime:PropTypes.number.isRequired,
  mythsAndFacts:PropTypes.array.isRequired
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  screenNumber:state.config.screenNumber,
  playTime:state.config.playTime,
  mythsAndFacts:state.localData.mythsAndFacts,
  israndamized:state.config.israndamized
});

export default connect(mapStateToProps,{setTime,isArrayRandamized,setRandomMythsAndFacts})(GameMainScreen);
//export default withRouter(MainMenuScreen);



// WEBPACK FOOTER //
// ./src/components/GameMainScreen.js